import { useEffect, useRef, useState } from "react";
import { Send, Users } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function LiveVideo({ videoEl, muted = false, className = "" }) {
  const box = useRef(null);
  useEffect(() => {
    const el = box.current;
    if (!el || !videoEl) return undefined;
    videoEl.muted = muted;
    videoEl.playsInline = true;
    videoEl.autoplay = true;
    videoEl.className = "w-full h-full max-h-[100dvh] object-contain bg-black";
    el.replaceChildren(videoEl);
    return () => { el.replaceChildren(); };
  }, [videoEl, muted]);
  return <div ref={box} className={`relative w-full h-full bg-black ${className}`} data-testid="live-video" />;
}

export function LiveChat({ messages, onSend, viewers, disabled, placeholder = "Say something…" }) {
  const [text, setText] = useState("");
  const list = useRef(null);
  useEffect(() => { if (list.current) list.current.scrollTop = list.current.scrollHeight; }, [messages.length]);
  return (
    <div className="flex flex-col h-full min-h-0" data-testid="live-chat">
      <div className="px-3 py-2 border-b border-white/10 text-xs text-neutral-400 flex items-center gap-1.5" data-testid="live-viewers"><Users className="h-3.5 w-3.5" />{viewers} watching</div>
      <div ref={list} className="flex-1 min-h-0 overflow-y-auto p-3 space-y-1.5 text-sm" data-testid="live-chat-messages">
        {messages.length === 0 && <div className="text-xs text-neutral-500">Be the first to cheer.</div>}
        {messages.map((m, i) => <div key={i}><span className={`font-semibold ${m.me ? "text-[#FF9F0A]" : "text-white"}`}>{m.from}</span> <span className="text-neutral-300">{m.text}</span></div>)}
      </div>
      <form onSubmit={(e) => { e.preventDefault(); if (!text.trim()) return; onSend(text); setText(""); }} className="p-2 border-t border-white/10 flex gap-2">
        <Input value={text} onChange={(e) => setText(e.target.value)} placeholder={placeholder} disabled={disabled} maxLength={400} data-testid="live-chat-input" className="bg-black/40 border-white/10 h-9" />
        <Button type="submit" size="icon" disabled={disabled} data-testid="live-chat-send" className="h-9 w-9 rounded-full bg-white text-black hover:bg-neutral-200"><Send className="h-4 w-4" /></Button>
      </form>
    </div>
  );
}
